import { apiService } from './api';

/**
 * Media service for handling file uploads
 */
export const mediaService = {
  /**
   * Upload media file
   * @param {File} file - File to upload
   * @returns {Promise<Object>} Upload response
   */
  uploadFileOnFacebook: async (projectId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    return await apiService.post('/media', formData);
  },

  /**
   * Upload media file for WhatsApp
   * @param {string} phoneNumberId - WhatsApp Phone Number ID
   * @param {File} file - File to upload
   * @returns {Promise<Object>} Upload response (contains id)
   */
  uploadWhatsAppMedia: async (projectId, phoneNumberId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    return await apiService.post(`/media/whatsapp/${phoneNumberId}`, formData);
  },

  /**
   * Upload media file for Facebook
   * @param {File} file - File to upload
   * @returns {Promise<Object>} Upload response
   */
  uploadFile: async file => {
    const formData = new FormData();
    formData.append('file', file);
    return await apiService.post('/media/upload', formData);
  },
};

export default mediaService;
